import React, { ChangeEventHandler } from 'react';
import FormControl from '@mui/material/FormControl';
import { emptyFn } from '@core/interfaces/emptyFn';
import InputComponent from '@ui/components/Input/Input.component';
import { lang } from '@lang/interfaces/lang';

interface IProps {
    lang: lang;
    ftpAddress: string;
    ftpPort: number | null;
    ftpLogin: string;
    ftpPassword: string;
    ftpDirectory: string;
    ftpFilename: string;
    onFtpAddressChange: ChangeEventHandler<HTMLInputElement>;
    onFtpPortChange: ChangeEventHandler<HTMLInputElement>;
    onFtpLoginChange: ChangeEventHandler<HTMLInputElement>;
    onFtpPasswordChange: ChangeEventHandler<HTMLInputElement>;
    onFtpDirectoryChange: ChangeEventHandler<HTMLInputElement>;
    onFtpFilenameChange: ChangeEventHandler<HTMLInputElement>;
    onInputClick: emptyFn;
}

const Component: React.FC<IProps> = ({
    lang,
    ftpAddress,
    ftpPort,
    ftpLogin,
    ftpPassword,
    ftpDirectory,
    ftpFilename,
    onFtpAddressChange,
    onFtpPortChange,
    onFtpLoginChange,
    onFtpPasswordChange,
    onFtpDirectoryChange,
    onFtpFilenameChange,
    onInputClick,
}: IProps) => {
    return (
        <FormControl className="device-settings__form" component="form">
            <InputComponent
                label="ftpAddress"
                name="ftp-address"
                type="text"
                description="ftpAddressTooltip"
                lang={lang}
                value={ftpAddress}
                onChange={onFtpAddressChange}
                onClick={onInputClick}
                onFocus={onInputClick}
            />
            <InputComponent
                label="ftpPort"
                name="ftp-port"
                type="number"
                description="ftpPortTooltip"
                numberProps={{
                    min: 0,
                    max: 65535,
                }}
                lang={lang}
                value={ftpPort}
                onChange={onFtpPortChange}
                onClick={onInputClick}
                onFocus={onInputClick}
            />
            <InputComponent
                label="ftpLogin"
                name="ftp-login"
                type="text"
                description="ftpLoginTooltip"
                lang={lang}
                value={ftpLogin}
                onChange={onFtpLoginChange}
                onClick={onInputClick}
                onFocus={onInputClick}
            />
            <InputComponent
                label="ftpPassword"
                name="ftp-password"
                description="ftpPasswordTooltip"
                lang={lang}
                value={ftpPassword}
                onChange={onFtpPasswordChange}
                onClick={onInputClick}
                onFocus={onInputClick}
            />
            <InputComponent
                label="ftpDirectory"
                name="ftpDirectory"
                type="text"
                description="ftpDirectoryTooltip"
                lang={lang}
                value={ftpDirectory}
                onChange={onFtpDirectoryChange}
                onClick={onInputClick}
                onFocus={onInputClick}
            />
            <InputComponent
                label="ftpFilename"
                name="ftpFilename"
                type="text"
                description="ftpFilenameTooltip"
                lang={lang}
                value={ftpFilename}
                onChange={onFtpFilenameChange}
                onClick={onInputClick}
                onFocus={onInputClick}
            />
        </FormControl>
    );
};

const UpdateServerSettingsComponent = React.memo(Component);

export default UpdateServerSettingsComponent;
